module.exports = __webpack_public_path__ + "static/media/man-with-loonguy.1b46e583.png";